// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `work-orders-signoff.component.case-btn-group {
  margin-bottom: 60px;
}

.customer-signature {
  border: solid #979797 1px;
}

.modal-dialog {
  max-width: 700px;
}

::ng-deep .n-o-c {
  display: inline-block !important;
}

.signature-center {
  width: 100%;
  margin: 0 auto;
  text-align: center;
}

.signature-center app-signature-field {
  margin: 0 auto;
  display: block;
}

.agree-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  margin-bottom: 20px;
}

.agree-button {
  background: transparent;
  border: 1px solid #ccc;
  padding: 8px 12px;
  border-radius: 8px;
  width: 100%;
  text-align: left;
  font-size: 16px;
}

.agree-button:active {
  opacity: 0.6;
}

/* --- Responsive UI Enhancements --- */
.personal-details-table {
  width: 100%;
  border-collapse: collapse;
}
@media screen and (max-width: 768px) {
  .personal-details-table tr {
    display: flex;
    flex-direction: column;
    margin-bottom: 12px;
  }
}
.personal-details-table td {
  padding: 6px 0;
  vertical-align: middle;
}
.personal-details-table td:first-child {
  font-weight: 600;
  color: #495057;
  width: 150px;
}
@media screen and (max-width: 768px) {
  .personal-details-table td:first-child {
    width: 100%;
    padding-bottom: 2px;
  }
}
@media screen and (max-width: 768px) {
  .personal-details-table td.px-3 {
    display: none; /* Hide the colon separator on mobile */
  }
}
.personal-details-table td input.form-control {
  width: 100%;
  max-width: 100%;
}

.personal-details-actions {
  display: flex;
  gap: 12px;
}
@media screen and (max-width: 768px) {
  .personal-details-actions {
    flex-direction: column;
    width: 100%;
  }
  .personal-details-actions button {
    width: 100% !important;
    margin-right: 0 !important;
    margin-bottom: 8px;
  }
}

.responsive-header {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding-bottom: 12px;
}
.responsive-header .header-title {
  margin: 0;
  font-weight: 500;
  font-size: 24px;
  line-height: 34px;
}
.responsive-header .header-actions {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
}
.responsive-header .header-actions button {
  margin: 0 !important;
}
@media screen and (max-width: 768px) {
  .responsive-header {
    flex-direction: column;
    align-items: stretch;
  }
  .responsive-header .header-title {
    text-align: left;
    font-size: 20px;
  }
  .responsive-header .header-actions {
    flex-direction: column;
    width: 100%;
  }
  .responsive-header .header-actions button {
    width: 100% !important;
    display: block;
    margin-bottom: 8px;
  }
}

.table-responsive-container {
  width: 100%;
  overflow-x: auto !important;
  -webkit-overflow-scrolling: touch;
  margin-top: 15px;
}
.table-responsive-container ::ng-deep .p-datatable {
  min-width: 950px; /* Force minimum width to allow horizontal scrolling on mobile */
}
.table-responsive-container ::ng-deep .p-datatable-scrollable-wrapper {
  overflow: visible !important; /* Force override to prevent cutting off scrollable body */
}
.table-responsive-container ::ng-deep .p-datatable-scrollable-body {
  overflow: auto !important;
}`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
